<template>
  <div
    v-if="text"
    :class="`mask-btn_summary-container ${type} ${
      maskedText ? 'maske-content-available' : 'no-maske-content'
    }`"
    style="overflow-y: auto; scrollbar-width: thin"
  >
    <div v-if="genarateMaskedLoader">
      <SkeletonLoader v-if="type == 'conversationHistory'" />
      <SpeechSkeleton v-else />
    </div>

    <div v-else>
      <div v-if="!maskedText" class="mask-btn_container">
        <div class="mask-btn-card">
          <p class="mask-btn_message">
            このデータはまだ匿名化されていません。<br />
            詳細を確認するには、匿名化が必要です。
          </p>
          <button
            class="mask-generate-button"
            @click="handleGenerateMaskedVersion(text, type, index)"
          >
            匿名化を開始する
          </button>
        </div>
      </div>
      <div v-else>
        <VueMarkdown>
          {{
            maskedText?.replace(/(^|\s)(\b(?!http|https)\w+):/g, "$1**$2**:")
          }}
        </VueMarkdown>
      </div>
    </div>
  </div>
  <div v-else :class="`mask-btn_summary-container ${type}`">
    <p class="text-center">N/A</p>
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";
import SpeechSkeleton from "@/components/SpeechSkeleton.vue";
import SkeletonLoader from "@/components/Loader/SkeletonLoader.vue";

export default {
  name: "MaskedTextView",
  components: {
    VueMarkdown,
    SpeechSkeleton,
    SkeletonLoader,
  },
  props: {
    genarateMaskedLoader: {
      type: Boolean,
      required: true,
    },
    callDetails: {
      type: Object,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    maskedText: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: false,
    },
    index: {
      type: Number,
      required: false,
    },
  },
  emits: ["generate"],
  computed: {
    // formattedMaskedText() {
    //   const text = this.maskedText || ''
    //   return text
    //     .replace(/(^|\s)(\b(?!http|https)\w+):/g, '$1**$2**:')
    //     .replace(/\。/g, '。\n')
    // },
  },
  methods: {
    handleGenerateMaskedVersion(text, type, index) {
      if (text) {
        this.$emit("generate", text, type, index);
      }
    },
  },
};
</script>
